import lodash from "lodash";
import { defineAsyncComponent, reactive } from "vue";
import i18n from "../../../../../i18n";
import { addModal } from "../../../../../app.logic";
import { modalStyleForm } from "../../../../../utils/constant";
//import { initUseForm } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { createColumnInput } from "../../../../../components/table/c-table.logic";
import { createFieldInput, createFieldTextArea } from "../../../../../components/input/template-builder/template-builder.logic";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import store from "../../../../../store";

export const { isLoading, setIsLoading } = createLoading();

export const ProcessForm = defineAsyncComponent(() => import("./ProcessForm"));

export const callHazDiscussResultNull = () => store.dispatch(`resource/v1/master/lookup/cacheFindAllByGroup`, { group: 'HAZ_DISCUSS_RESULT' })
    .then(items => items.filter(item => ["1"].includes(item.key)));

export const callHazDiscussDofControlNull = () => store.dispatch(`resource/v1/master/lookup/cacheFindAllByGroup`, { group: 'HAZ_DISCUSS_DOF_CONTROL' });

export const openModalForm = ({ props, data,/*onOk,*/ bind }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okButtonProps: { disabled: false },
                cancelButtonProps: { style: { "display": "none" } },
                okText: i18n.global.t("button.close"),
                title: i18n.global.t("views.request.modal.process"),
                width: "1000px",
                onOk: () => {
                    options.bind.onCancel();
                }
            },
            bind
        ),
        render: () => (
            <ProcessForm
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
                dataProp={data}
                itemsKey={"refHazDiscussTemp"}
            ></ProcessForm>
        )
    });
    return options;
};

export const createColumns = () => {
    return [
        createColumnInput({
            title: () => i18n.global.t("views.request.hazDiscuss.subStance"),
            dataIndex: "refSubStanceProcess.name",
            dataIndexValue: ({ record }) =>
                record.refSubStanceProcess == null
                    ? record.otherSubStance
                    : record.refSubStanceProcess?.name,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.hazDiscuss.subStanceKind"),
            dataIndex: "refSubStanceProcess.refSpecies.key",
            dataIndexValue: ({ record }) =>
                record.refSubStanceProcess == null || record.refSubStanceProcess?.refSpecies == null
                    ? '-'
                    : record.refSubStanceProcess?.refSpecies.key,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false },
            width: 100
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.hazDiscuss.subStanceType"),
            dataIndex: "refSubStanceProcess.refType.value",
            dataIndexValue: ({ record }) =>
                record.refSubStanceProcess == null
                    ? '-'
                    : record.refSubStanceProcess?.refType.value,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false },
            width: 120
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.hazDiscuss.subStanceIntense"),
            dataIndex: "intense",
            search: { visible: () => false },
            align: "center",
            width: 100
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.hazDiscuss.subStanceCondition"),
            dataIndex: "dofControl",
            align: "center",
            search: { visible: () => false }
        }),
    ];
};

export const createField = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const prefix = itemsKey ? `${itemsKey}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}tradeNameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.tradeNameTh"),
                inputProp: ({ field }) =>
                lodash.merge(
                    {
                        value: model.tradeNameEn,
                        disabled: true
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refMainObjective`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.refMainObjective"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refMainObjective.value,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSubObjective`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.refSubObjective"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSubObjective.value,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refMainOperation`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.refMainOperation"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refMainOperation.value,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSubOperation`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.refSubOperation"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSubOperation.value,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refResult`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.hazDiscuss.result"),
                inputProp: ({ field }) =>
                lodash.merge(
                    {
                        value: !model.refResult ? data.resultNull[0].value : model.refResult?.answer,
                        disabled: true,
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                )
            }),
        ]
    });
};

export const createPage = ({ data, options }) => {
    return lodash.merge(
        {
            select: ["*"],
            join: [],
            where: [],
            sort: [],
            children: [],
            page: 0,
            size: 5,
            totalPage: 1,
            totalSize: data ? data.length : 0,
            isRecursive: false,
            isChildrenDataOnly: true,
            data: data ? data : []
        },
        options
    );
};

export const initForm = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.fields = createField({ props, data });
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items?.mainSubStances });
    data.tableOptions = { 
        search: { activeKey: null },
        visibleSearch: false,
     };
    //fetchData({ props, data }).then(page => items.push(...page.data));
};

/*export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};*/